import React, {Component} from 'react';
import {Icon, Card, CardText, CardActions, Button } from 'react-mdl';
import autoBind from 'react-autobind';

class Success extends Component {
  constructor(props) {
    super(props);
    this.state = Object.assign({}, props, {
      toAddress: "",
      postLoaded: false,
      note: ""
    });
    autoBind(this);
  }
  handleSubmit(e) {
    e.preventDefault();
    console.log('redirecting....')
    window.location.href = "http://ibankcoin.com";
  }
  render() {
    return (
      <div className="main">
        <div className="content-header">
          <Icon name="check_circle" style={{fontSize: '40px'}} />
          <h3>Message sent!</h3>
        </div>
        <Card shadow={0} style={{margin: 'auto', minHeight: '100px'}}>
          <CardText>
            <strong>Your communique has been successfully dispatched. Thanks for spreading the word.</strong><br />
          </CardText>
          <CardActions border style={{textAlign: 'right', padding: '20px'}}>
            <Button onClick={this.handleSubmit} raised colored>Back to iBankCoin</Button>
          </CardActions>
        </Card>
      </div>
    );
  }
}

export default Success;



/** WEBPACK FOOTER **
 ** ./src/components/Success.js
 **/